import * as Utils from "@/utils";
namespace Constants {
  export const LOGGER_DEV = window.localStorage.getItem("LOGGER_DEV") === "1";

  /** 是否为开发环境 */
  export const IS_DEV = import.meta.env.MODE === "dev";

  export const GAME_ID = Number(import.meta.env.VITE_GAME_ID);

  /** 是否为开发/测试环境 */
  export const IS_DEBUG = import.meta.env.VITE_IS_DEBUG != null
    ? import.meta.env.VITE_IS_DEBUG === "true"
    : import.meta.env.MODE !== "production";

  /** TAF 接口是否使用测试环境 */
  export const IS_TAF_TEST = __TAF_ENV__ === "test";

  /** 是否使用debug模式；使用时会打开vconsole */
  export const IS_USEDEBUG = Utils.getDebugFlag() === "1";
}

export default Constants;
